import { createContext } from "react";
import type { CopilotActionView } from "@/features/copilot/schemas/copilot.schema";

export interface CopilotActionContextValue {
  workspaceSlug: string;
  actions: ReadonlyMap<string, CopilotActionView>;
  canRespond: boolean;
  runtimeIsIdle: boolean;
  approvalSending: boolean;
  respondToAction: (submit: () => Promise<void>, runtimeIsIdle: boolean) => Promise<void>;
}

export const CopilotActionContext = createContext<CopilotActionContextValue | null>(null);
